var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ProductRatingStars flex items-center space-x-1"},_vm._l((5),function(i){return _c('svg-icon',{key:i,staticClass:"w-4 h-4",class:{
      'is-active': _vm.rating >= i,
    },attrs:{"name":_vm.rating >= i ? 'star' : 'star-dimmed'}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }